var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"proc-component"},[_c('v-card-title',{class:_vm.btnColor},[_c('icon-svg',{attrs:{"size":_vm.procIconSize,"iconName":_vm.btnIcon}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }